import CurrencyInput from "react-currency-input-field";
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import api from '../../../../config/axios';

import { FaRegSave, FaTimes } from 'react-icons/fa';

const SangriaSuprimentoModal = ({ onClose, caixa, tipoOperacao, onOperacaoRealizada }) => {
    const [formData, setFormData] = useState({
        valor: '',
        descricao: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.valor) {
            Swal.fire('Erro', 'O campo Valor é obrigatório', 'error');
            return;
        }

        if (!formData.descricao.trim()) {
            Swal.fire('Erro', 'O campo Descrição é obrigatório', 'error');
            return;
        }

        const result = await Swal.fire({
            title: 'Atenção!',
            text: `Confirmar a ${tipoOperacao} no valor de R$ ${parseFloat(formData.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, confirmar!',
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) {
            return;
        }

        const dadosOperacao = {
            caixa_id: caixa.id,
            tipo_operacao: tipoOperacao,
            valor: parseFloat(formData.valor),
            descricao: formData.descricao.trim()
        };

        Swal.fire({
            title: "Carregando...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            await api.post('/caixas/operacao', dadosOperacao);

            if (onOperacaoRealizada) {
                onOperacaoRealizada();
            }

            onClose();
            Swal.fire('Sucesso', `${tipoOperacao === 'sangria' ? 'Sangria' : 'Suprimento'} realizada com sucesso!`, 'success');
        } catch (error) {
            Swal.fire('Erro', error.response.data.message || 'Erro ao realizar a operação. Tente novamente.', 'error');
        }
    };

    const tituloModal = tipoOperacao === 'sangria' ? 'Sangria do Caixa' : 'Suprimento do Caixa';

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-md modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">{tituloModal}</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <div className="row">
                            <div className="col-12">
                                <strong>Responsável:</strong> {caixa?.colaborador?.nome}
                            </div>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="row mt-3">
                                <div className="col-lg-6 col-12">
                                    <label className="form-label fw-bold">Valor</label>
                                    <CurrencyInput
                                        name="valor"
                                        placeholder="R$ 0,00"
                                        value={formData.valor}
                                        decimalsLimit={2}
                                        decimalSeparator=","
                                        groupSeparator="."
                                        prefix="R$ "
                                        className="form-control"
                                        autoComplete="off"
                                        onValueChange={(value) =>
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                valor: value,
                                            }))
                                        }
                                    />
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-12">
                                    <label className="form-label fw-bold">Descrição</label>
                                    <textarea
                                        className="form-control"
                                        name="descricao"
                                        rows={4}
                                        value={formData.descricao}
                                        onChange={handleChange}
                                        maxLength={255}
                                    />
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="modal-footer mt-4">
                        <div className="row">
                            <div className="col-12 text-end">
                                <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                                    <FaTimes /> Fechar
                                </button>
                                <button className="btn btn-custom-primary ms-3" type="submit" onClick={handleSubmit}>
                                    <FaRegSave /> Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SangriaSuprimentoModal; 